import React, { useState } from 'react';
import NewsletterSubscription from './NewsletterSubscription';
import { t } from '../i18n';

const NewsletterPopup = ({ isLoggedIn, token }) => {
  const [isVisible, setIsVisible] = useState(true); // State to control visibility

  const handleClose = () => {
    setIsVisible(false); // Hide the popup when the close button is clicked
  };

  if (!isVisible) return null; // Don't render the popup if it's not visible

  return (
    <div style={styles.popup}>
      <button onClick={handleClose} style={styles.closeButton} aria-label={t('close') || 'Fermer'}>
        ✖
      </button>
      <NewsletterSubscription
        isLoggedIn={isLoggedIn}
        token={token}
        customStyles={styles.subscriptionContainer} // Pass custom styles for the container
        customButtonStyles={styles.subscribeButton} // Pass custom styles for the button
      />
    </div>
  );
};

const styles = {
  popup: {
    position: 'fixed',
    bottom: '64px', // Move above FooterBar (38px height + margin)
    right: '20px',
    height: 'auto', // Auto height to fit content
    width: '300px', // Fixed width
    backgroundColor: 'var(--green-eucalyptus)',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    zIndex: 1000,
    padding: '10px',
    overflow: 'hidden', // Ensure content doesn't overflow
  },
  closeButton: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    color: 'white',
    backgroundColor: 'var(--green-eucalyptus)',
  },
  subscriptionContainer: {
    marginTop: '0px',
    marginBottom: '0px',
    backgroundColor: 'var(--green-eucalyptus)', // Custom background color for NewsletterSubscription
    borderRadius: '5px',
    padding: '5px',
    fontSize: '14px',
    color: 'white',
  },
  subscribeButton: {
    backgroundColor: 'white', // Custom button background color
    color: 'var(--green-eucalyptus)', // Custom button text color
    border: '1px solid var(--green-eucalyptus)', // Custom border
    fontWeight: 'bold',
    marginTop: '10px',
    marginBottom: '0px',
  },
};

export default NewsletterPopup;